import Component from '@glimmer/component';
import { action } from '@ember/object';
import dispatcher from 'mewe/dispatcher';

export default class MwDesktopNotificationsRequest extends Component {
  @action
  openNotificationsRequest() {
    dispatcher.dispatch('notification', 'requestPermissions');
  }

  @action
  closeNotificationHeaderPermanently() {
    dispatcher.dispatch('notification', 'hidePermanently');
  }

  @action
  closeNotificationHeaderShort() {
    dispatcher.dispatch('notification', 'turnOffShort');
  }
}
